module.exports = __webpack_public_path__ + "static/media/img-axum-thumb@2x.4bf1df0e.png";